/* 正式版本 */
import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { useAppSelector } from '@/redux/hooks'

// Methods
import handleLogout from '@/methods/handleLogout'

// Components
import Image from '@/components/common/Image'
import Link from '@/components/common/Link'
import LanguageSelector from '@/components/shared/LanguageSelector'

// Constants
import { ROUTE_PATH } from '@/constants/routePath'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

const WebHeader = () => {
  const { t } = useTranslation()

  const memberData = useAppSelector((state) => state?.member?.memberData)

  const hasUserData = !!memberData?.memberInfoId

  const handleLogoutClick = () => {
    handleLogout()
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        {/* Logo */}
        <Link pathname={ROUTE_PATH.EXPLORE}>
          <div className={cx('header__logo')}>
            <Image src={`/images/svg/logo_live_mall_club.svg`} fill alt={'LiveMallClub'} />
          </div>
        </Link>

        {/* Right Actions */}
        <div className={cx('header__actions')}>
          {hasUserData && (
            <>
              {/* User Info */}
              <div className={cx('header__user')}>
                <div className={cx('header__user-avatar')}>
                  <Image src={memberData.headshotUrl} fill alt={memberData?.nickName || 'User'} style={{ objectFit: 'cover' }} />
                </div>
                <span className={cx('header__user-name')}>{memberData?.nickName}</span>
              </div>

              {/* Logout Button */}
              <button className={cx('header__logout-btn')} onClick={handleLogoutClick}>
                {t('Common_Logout') || 'log out'}
              </button>
            </>
          )}

          {/* Language Selector */}
          <LanguageSelector className={cx('header__language')} />
        </div>
      </div>
    </header>
  )
}

export default WebHeader
